module.exports = __webpack_public_path__ + "media/src/img/payment/yandex-logo2-f08d1486173f52ac536fee7727af86ef.svg";